<!-- https://bootsnipp.com/snippets/67z63 -->
<br />
<div class="container">
  <div class="row">
    <!-- Dashboard -->
    <div class="col">
      <a [routerLink]="'../dashboard'">
        <div class="card">
          <img class="card-img-top" src="./assets/images/Dashboard.jpg">
          <div class="card-overlay">
            <h4 class="card-title">Dashboards</h4>
            <div class="card-text">Charts and Events & Action Views</div>
          </div>
        </div>
      </a>
    </div>

    <!-- User Documentation: the link comes from the Settings table (UserDocumentationUrl) -->
    <div class="col" [title]="userDocumentationUrl ? '' : 'User documentation link has not been configured'">
      <a [href]="userDocumentationUrl" target="_blank" rel="noopener" [class.tile-disabled]="!userDocumentationUrl">
        <div class="card">
          <img class="card-img-top" src="./assets/images/ComputerMessages.jpg">
          <div class="card-overlay">
            <h4 class="card-title">User Documentation</h4>
            <div class="card-text">User Guides</div>
          </div>
        </div>
      </a>
    </div>

    <!-- User Groups -->
    <div class="col">
      <a [routerLink]="'../usergroups'">
        <div class="card">
          <img class="card-img-top" src="./assets/images/UserGroups.jpg">
          <div class="card-overlay">
            <h4 class="card-title">User Groups</h4>
            <div class="card-text">Custom User Access Group</div>
          </div>
        </div>
      </a>
    </div>

    <!-- Gatways -->
    <div class="col">
      <a [routerLink]="'../register'">
        <div class="card">
          <img class="card-img-top" src="./assets/images/StLoiusArch.jpg">
          <div class="card-overlay">
            <h4 class="card-title">Gateways</h4>
            <div class="card-text">Monitor and Configure</div>
          </div>
        </div>
      </a>
    </div>

    <!-- Sensors -->
    <div class="col">
      <a [routerLink]="'../sensors'">
        <div class="card">
          <img class="card-img-top" src="./assets/images/XiaomiSensor.png">
          <div class="card-overlay">
            <h4 class="card-title">Sensors</h4>
            <div class="card-text">Physical and Virtual Sensors</div>
          </div>
        </div>
      </a>
    </div>
    <!-- </div> -->

    <!-- <div class="row"> -->
    <!-- Sensor Groups -->
    <div class="col">
      <a [routerLink]="'../sensorgroups'">
        <div class="card">
          <img class="card-img-top" src="./assets/images/SensorGroups.jpg">
          <div class="card-overlay">
            <h4 class="card-title">Sensor Groups</h4>
            <div class="card-text">Groups of Sensors</div>
          </div>
        </div>
      </a>
    </div>

    <!-- Events and Actions -->
    <div class="col">
      <a [routerLink]="'../events'">
        <div class="card">
          <img class="card-img-top" src="./assets/images/Schedule.jpg">
          <div class="card-overlay">
            <h4 class="card-title">Events & Actions</h4>
            <div class="card-text">Monitor Conditions, Trigger Actions</div>
          </div>
        </div>
      </a>
    </div>

    <!-- Imports -->
    <div class="col">
      <a [routerLink]="'../import'">
        <div class="card">
          <img class="card-img-top" src="./assets/images/Spreadsheet.jpg">
          <div class="card-overlay">
            <h4 class="card-title">Import Readings</h4>
            <div class="card-text">Timer and Manual Imports</div>
          </div>
        </div>
      </a>
    </div>

    <!-- Sensor Readings -->
    <div class="col">
      <a [routerLink]="'../sensorreadings'">
        <div class="card">
          <img class="card-img-top" src="./assets/images/Charts.jpg">
          <div class="card-overlay">
            <h4 class="card-title">Sensor Readings</h4>
            <div class="card-text">Review, Chart, Map Readings</div>
          </div>
        </div>
      </a>
    </div>

    <!-- Scoutview -->
    <div class="col">
      <a [routerLink]="'../scoutview'">
        <div class="card">
          <img class="card-img-top" src="./assets/images/CameraSensor.jpg">
          <div class="card-overlay">
            <h4 class="card-title">Scoutview</h4>
            <div class="card-text">Image Capture and Processing</div>
          </div>
        </div>
      </a>
    </div>
  </div>

  <!-- Troubleshooting: clear the browser-saved settings for an individual page in
       case a stale saved search or page state keeps that page from loading. -->
  <p-confirmDialog key="clearSettings" #clearSettingsDialog>
    <ng-template #footer>
      <button type="button" class="btn btn-danger" (click)="clearSettingsDialog.onAccept()">Clear All</button>
      <button type="button" class="btn btn-basic" (click)="clearSettingsDialog.onReject()">Cancel</button>
    </ng-template>
  </p-confirmDialog>

  <div class="settings-panel">
    <div class="settings-panel-header" (click)="toggleSettingsPanel()"
         title="Clear browser-saved page settings if a page will not load">
      <i class="fas" [ngClass]="settingsPanelExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
      <label>Clear Saved Page Settings</label>
      <span class="settings-panel-count">{{ totalSavedGroups }} of {{ cachedSettingsGroups.length }} have saved settings</span>
    </div>

    <div *ngIf="settingsPanelExpanded" class="settings-panel-body">
      <div class="settings-panel-note">
        Each page remembers your last search and selections in this browser. If a page will not
        load, clear its saved settings here and revisit the page. This does not sign you out.
      </div>

      <div *ngFor="let group of cachedSettingsGroups" class="settings-row">
        <div class="settings-row-text">
          <div class="settings-row-label">{{ group.label }}</div>
          <div class="settings-row-description">{{ group.description }}</div>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                [disabled]="!hasSavedSettings(group)"
                (click)="clearSettingsGroup(group)">
          {{ hasSavedSettings(group) ? 'Clear' : 'Nothing Saved' }}
        </button>
      </div>

      <div class="settings-row settings-row-all">
        <div class="settings-row-text">
          <div class="settings-row-label">All Pages</div>
          <div class="settings-row-description">Clear every saved setting listed above</div>
        </div>
        <button type="button" class="btn btn-sm btn-danger"
                [disabled]="totalSavedGroups === 0"
                (click)="clearAllSettingsConfirm()">Clear All</button>
      </div>
    </div>
  </div>

  <!-- Search across the app; its results show below the box -->
  <app-global-search></app-global-search>
</div>
